<template>
  <div class="animated fadeIn ordenes-subtrabajos">
    <b-row>
      <b-col cols="12">
        <b-card no-header>
          <b-form>
            <b-form-group
              label="Tipo de Artículo"
              label-for="articuloTipo"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarArticuloTipo">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="agregarArticuloTipo">
                  <b-input-group-text>
                    <i class="fa fa-plus"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="editarArticuloTipo"
                    v-if="articuloTipo">
                  <b-input-group-text>
                    <i class="fa fa-edit"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="articuloTipo"
                  :value="articuloTipo"
                  :state="articuloTipoValido"
                  readonly
                  type="text"/>
                <b-form-invalid-feedback id="articuloTipoFeedback">
                  {{ articuloTipoInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Proveedor"
              label-for="proveedor"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarProveedor">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !proveedor,
                                  'fa fa-remove': proveedor  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="agregarProveedor">
                  <b-input-group-text>
                    <i class="fa fa-plus"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="proveedor"
                  :value="proveedor"
                  :state="proveedorValido"
                  readonly
                  type="text"/>
                <b-form-invalid-feedback id="proveedorFeedback">
                  {{ proveedorInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Descripción"
              label-for="observaciones"
              :label-cols="labelCols"
              description="Descripción a incluir en la orden al proveedor"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="5"
                max-rows="5"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-row>
              <b-col cols="12" md="6">
                <app-moneda
                  label="Moneda"
                  :nombre="moneda"
                  :labelCols="labelCols * 2"
                  :valido="monedaValida"
                  :lista="monedasList"
                  :msjInvalido="monedaInvalidaMsj"
                  @validate="validate"
                  @updated="monedaActualizada">
                </app-moneda>  

                <b-form-group
                  label="Cantidad"
                  label-for="cantidad"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="cantidad"
                    v-model.trim="$v.cantidad.$model" 
                    :state="cantidadValida"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="cantidadFeedback">
                    {{ cantidadInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  v-if="costoRemitos"
                  label="Costo Unitario"
                  label-for="costo"
                  description="Costo Unitario IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                      <!-- :value="costo"  -->
                    <b-form-input 
                      id="costo" 
                      value="---.--"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group
                  v-if="!costoRemitos"
                  label="Costo Unitario"
                  label-for="costo"
                  description="Costo Unitario IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-radio v-model="costoUnitario" 
                        name="costoUnitarioSelected" 
                        :value="Boolean(true)"
                        class="radio-group">
                      </b-form-radio>
                    </b-input-group-prepend>
                    <b-form-input 
                      id="costo" 
                      v-model.trim= "$v.costo.$model" 
                      type="text"
                      :readonly="costoDisabled"
                      :state="costoValido"
                      @blur.native="validate"
                      @input.native="calcularCostoTotal">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="costoFeedback">
                    {{ costoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  v-if="costoRemitos"
                  label="Costo Total"
                  label-for="costoTotal"
                  description="Costo Total IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                      <!-- :value="costoTotal"  -->
                    <b-form-input 
                      id="costoTotal" 
                      value="---.--"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group
                  v-if="!costoRemitos"
                  label="Costo Total"
                  label-for="costoTotal"
                  description="Costo Total IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-radio v-model="costoUnitario" 
                        name="costoTotalSelected" 
                        :value="Boolean(false)"
                        class="radio-group">
                      </b-form-radio>
                    </b-input-group-prepend>
                    <b-form-input 
                      id="costoTotal" 
                      v-model.trim= "$v.costoTotal.$model" 
                      type="text"
                      :readonly="costoTotalDisabled"
                      :state="costoTotalValido"
                      @blur.native="validate"
                      @input.native="calcularCostoUnitario">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="costoTotalFeedback">
                    {{ costoTotalInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="Dias Producción"
                  label-for="diasProduccion"
                  :label-cols="labelCols * 2"
                  horizontal
                  description="Dias hábiles para producción (sólo números)">
                  <b-form-input 
                    id="diasProduccion"
                    v-model.trim= "$v.diasProduccion.$model" 
                    :state="diasProduccionValidos"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="diasProduccionFeedback">
                    {{ diasProduccionInvalidosMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  :label-cols="labelCols"
                  description="Subtrabajo de Logística (permite asociar remitos)"
                  horizontal>
                  <b-form-checkbox 
                      id="logistica"
                      v-model="logistica"
                      :disabled="subtrabajoLogistica"
                      :value="true"
                      :unchecked-value="false">
                      Logística
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  :label-cols="labelCols"
                  description="Costo actualizado a través de remitos asociados"
                  horizontal>
                  <b-form-checkbox 
                      id="costoRemitos"
                      v-model="costoRemitos"
                      :disabled="costoRemitosDisabled"
                      :value="true"
                      :unchecked-value="false">
                      Costo según Remitos
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>

          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>             

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    
    <b-modal ref="searchArticuloTipoModal"
        title="Seleccionar Tipo de Artículo"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-articulo-tipo
        :loadRubros="Boolean(true)"
        @articuloTipoSeleccionado="articuloTipoSeleccionado">
      </app-search-articulo-tipo>  
    </b-modal>

    <b-modal ref="articuloTipoModal"
        title="Datos del Tipo Artículo"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-articulo-tipo
        :modal="true"
        :articuloTipoId="articuloTipoSeleccionadoId"
        @updateArticuloTipo="updateArticuloTipo"
        @closeArticuloTipo="closeArticuloTipo">
      </app-articulo-tipo>  
    </b-modal>

    <b-modal ref="proveedorModal"
        title="Alta de Proveedores"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-proveedor
        @updateProveedor="updateProveedor"
        @closeProveedor="closeProveedor">
      </app-proveedor>  
    </b-modal>

    <b-modal ref="searchProveedorModal"
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>
  </div>
</template>

<script>
import SearchArticuloTipo from '../articulosTipos/SearchList.vue';
import ArticuloTipo from '../articulosTipos/ABM.vue';
import SearchProveedor from '../proveedores/SearchList.vue';
import Proveedor from '../proveedores/Alta.vue';
import Moneda from '../shared/abmSelect.vue';
import { required, numeric, decimal, minValue, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'ordenSubtrabajo/getField',
  mutationType: 'ordenSubtrabajo/updateField',
});

export default {
  name: 'ABM',
  components: {
    appSearchArticuloTipo: SearchArticuloTipo,
    appArticuloTipo: ArticuloTipo,
    appSearchProveedor: SearchProveedor,
    appProveedor: Proveedor,
    appMoneda: Moneda
  },
  props: {
    subtrabajoLogistica: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',

      noValidar: true,
      articuloTipoValido: null,
      articuloTipoInvalidoMsj: '',
      cantidadValida: null,
      cantidadInvalidaMsj: '',
      monedaValida: null,
      monedaInvalidaMsj: '',
      proveedorValido: null,
      proveedorInvalidoMsj: '',
      costoValido: null,
      costoInvalidoMsj: '',
      costoTotalValido: null,
      costoTotalInvalidoMsj: '',
      diasProduccionValidos: null,
      diasProduccionInvalidosMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      articuloTipoSeleccionadoId: 0,

      noValidar: true,
      tableBusy: false,
      monedas: [],
      monedasList: [],

      labelCols: 2,
      inicializandoMonedas: false,
    }
  },
  computed: {
    ...mapFields([
      'ordenTrabajoId',
      'ordenSubTrabajo',
      'articuloTipoId',
      'articuloTipo',
      'cantidad',
      'monedaId',
      'moneda',
      'proveedorId',
      'proveedor',
      'costo',
      'costoTotal',
      'costoUnitario',
      'diasProduccion',
      'logistica',
      'costoRemitos',
      'observaciones',
    ]),
    costoDisabled() {
      return !this.costoUnitario;
    },
    costoTotalDisabled() {
      return Boolean(this.costoUnitario);
    },
    costoRemitosDisabled() {
      return !this.logistica;
    }
  },  
  created() {
    this.getDatosAdicionales();
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      this.inicializandoMonedas = true;
      this.$store.dispatch('monedas/getList')
        .then(() => {
          this.monedas = this.$store.getters['monedas/list'];
          this.monedasList = this.$store.getters['monedas/selectList'];
          this.inicializandoMonedas = false;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de monedas.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'cantidad' || validarTodos) {
        if (this.$v.cantidad.$error) {
          this.cantidadValida = false;
          if (!this.$v.cantidad.decimal || !this.$v.cantidad.minValue) {
            this.cantidadInvalidaMsj = 'La cantidad debe ser un valor numérico positivo';
          }
        } else {
          this.cantidadValida = null;
          this.cantidadInvalidaMsj = '';
        }
      }

      if (this.costoUnitario) {
        if (campo == 'costo' || validarTodos) {
          if (this.$v.costo.$error) {
            this.costoValido = false;
            if (!this.$v.costo.decimal || !this.$v.costo.minValue) {
              this.costoInvalidoMsj = 'El costo ingresado no es válido';
            }
          } else {
            this.costoValido = null;
            this.costoInvalidoMsj = '';
          }
        }
      } else {
        if (campo == 'costoTotal' || validarTodos) {
          if (this.$v.costoTotal.$error) {
            this.costoTotalValido = false;
            if (!this.$v.costoTotal.decimal || !this.$v.costoTotal.minValue) {
              this.costoTotalInvalidoMsj = 'El costo total ingresado no es válido';
            }
          } else {
            this.costoTotalValido = null;
            this.costoTotalInvalidoMsj = '';
          }
        }
      }

      if (campo == 'diasProduccion' || validarTodos) {
        if (this.$v.diasProduccion.$error) {
          this.diasProduccionValidos = false;
          if (!this.$v.diasProduccion.numeric || !this.$v.diasProduccion.minValue) {
            this.diasProduccionInvalidosMsj = 'La cantidad de días de producción debe ser un valor numérico positivo';
          }
        } else {
          this.diasProduccionValidops = null;
          this.diasProduccionInvalidosMsj = '';
        }
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'La descripción solo puede contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      let save = Boolean(true);

      let articuloTipoError = true;
      if (this.articuloTipoId) {
        if (this.articuloTipoId != 0) {
          articuloTipoError = false;
        }
      }
      if (articuloTipoError) {
        save = Boolean(false);
        this.articuloTipoValido = false;
        this.articuloTipoInvalidoMsj = 'Debe seleccionar el tipo de artículo correspondiente.';
      }

      let errorMoneda = true;
      if (this.monedaId) {
        if (this.monedaId != 0) {
          errorMoneda = false;
        }
      }
      if (errorMoneda) {
        this.monedaValida = false;
        this.monedaInvalidaMsj = 'Debe seleccionar la moneda correspondiente.';
        save = false;
      }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let params = {
            produccion: true
          }

          /* Validamos si corresponde a logistica o a producción */
          if ((/true/i).test(this.subtrabajoLogistica)) {
            params.produccion = false;
          }

          this.showSpinner();
          this.$store.dispatch('ordenSubtrabajo/save', params)
            .then(() => this.$emit('updateSubtrabajo'))
            .catch(error => this.showAlert(error, 'danger'))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goBack() {
      this.$emit('closeSubtrabajo');
    },
    seleccionarArticuloTipo() {
      this.$refs.searchArticuloTipoModal.show();
    },
    articuloTipoSeleccionado(item) {
      this.$refs.searchArticuloTipoModal.hide();
      this.$store.dispatch('ordenSubtrabajo/setArticuloTipo', item.id)
        .catch(error => this.showAlert(error, 'danger'));
    },
    seleccionarProveedor() {
      if (this.proveedorId != 0) {
        this.$store.dispatch('ordenSubtrabajo/setProveedor');
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    proveedorSeleccionado(item) {
      this.$refs.searchProveedorModal.hide();
      this.$store.dispatch('ordenSubtrabajo/setProveedor', item)
        .catch(error => this.showAlert(error, 'danger'));
    },
    agregarArticuloTipo() {
      this.articuloTipoSeleccionadoId = 0;
      this.$refs.articuloTipoModal.show();
    },
    editarArticuloTipo() {
      this.articuloTipoSeleccionadoId = this.articuloTipoId;
      this.$refs.articuloTipoModal.show();
    },
    updateArticuloTipo(articuloTipo) {
      this.$refs.articuloTipoModal.hide();
      this.$store.dispatch('ordenSubtrabajo/setArticuloTipo', articuloTipo.id)
        .catch(error => this.showAlert(error, 'danger'));
    },
    closeArticuloTipo() {
      this.$refs.articuloTipoModal.hide();
    },
    agregarProveedor() {
      this.$refs.proveedorModal.show();
    },
    updateProveedor(proveedor) {
      let proveedorDatos = {
        id: proveedor.id,
        nombre: proveedor.nombreComercial.trim()
      }

      this.$refs.proveedorModal.hide();
      this.$store.dispatch('ordenSubtrabajo/setProveedor', proveedorDatos)
        .catch(error => this.showAlert(error, 'danger'));
    },
    closeProveedor() {
      this.$refs.proveedorModal.hide();
    },
    calcularCostoUnitario() {
      this.$store.dispatch('ordenSubtrabajo/calcularCostoUnitario');
    },
    calcularCostoTotal() {
      this.$store.dispatch('ordenSubtrabajo/calcularCostoTotal');
    },
    monedaActualizada(monedaNombre) {
      if (!this.inicializandoMonedas) {
        this.moneda = monedaNombre;

        if (this.moneda) {
          let moneda = this.getSelected(this.monedas, this.moneda);
          this.$store.dispatch('ordenSubtrabajo/setMoneda', moneda)
            .catch(error => this.showErrorMsj(error))

          this.monedaValida = null;
          this.monedaInvalidaMsj = '';
        }
      }
    },
  },
  validations: {
    cantidad: {
      required,
      decimal,
      minValue: minValue(0)
    },
    costo: {
      decimal,
      minValue: minValue(0)
    },
    costoTotal: {
      decimal,
      minValue: minValue(0)
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
    diasProduccion: {
      numeric,
      minValue: minValue(0)
    },
  },
  watch: {
  }  
}
</script>

<style>
</style>
